import { createVanIconComponent } from "./van"

const PointGift = createVanIconComponent("point-gift")
export default PointGift
